import RoleRepository from "../repository/role-repository";

class RoleService
{
    #roleRepository;

    constructor() {
        this.#roleRepository = new RoleRepository();
    }

    async findAll() {
        try {
            const data = await this.#roleRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#roleRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            const data = await this.#roleRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async create(user) {
        try {
            const data = await this.#roleRepository.create(user);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(user) {
        try {
            const data = await this.#roleRepository.edit(user);

            return data;
        } catch (error) {;
            console.error(error);
        }
    }
}

export default RoleService;